import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { hasSubmitFailed } from 'redux-form';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { triggerEnsightenEvent } from '../../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_APP_START, ENSIGHTEN_APP_SOFT_DECLINED } from '../../../../framework/store/Ensighten/EnsightenConstants';

import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import ApplyPageForm from './ApplyPageForm/ApplyPageForm';
import { FLOW_TYPE, FORM_ID } from '../../../../framework/App/AppConstants';
import NotificationBanner, { NOTIFICATION_TYPE } from '../../../../shared-components/NotificationBanner/NotificationBanner';
import DEFooter from '../../../components/Footer/DEFooter/DEFooter';
import '../../../styles/base-de.less';
const LOCALE_PREFIX = 'DE/pages/ApplyPage/ApplyPage';

export class ApplyPage extends Component {
    static propTypes = {
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)).isRequired,
        hasSoftDeclineMsg: PropTypes.bool,
        hasSubmitFailed: PropTypes.bool,
        intl: intlShape.isRequired,
        invalidAddressMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        messages: PropTypes.object.isRequired,
        showValidationSoftDecline: PropTypes.bool,
        softDeclineCustomMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        hasSoftDeclineMsg: false,
        hasSubmitFailed: false,
        showValidationSoftDecline: false,
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
    }

    getNotifications = () => {
        const {
            hasSoftDeclineMsg,
            hasSubmitFailed,
            intl,
            invalidAddressMsg,
            messages,
            showValidationSoftDecline,
            softDeclineCustomMsg,
        } = this.props;
        let notificationMessage;
        let notificationType;

        if (hasSubmitFailed) {
            notificationMessage = intl.formatMessage({ id: `${LOCALE_PREFIX}.applyForBml.fieldError` });
            notificationType = NOTIFICATION_TYPE.WARNING;
        }
        if (invalidAddressMsg) {
            notificationMessage = intl.formatMessage({ id: `${LOCALE_PREFIX}.applyForBml.softDeclineAddressMessage` });
            notificationType = NOTIFICATION_TYPE.WARNING;
        }
        if (showValidationSoftDecline || hasSoftDeclineMsg) {
            const defaultSoftDeclineMessage = intl.formatMessage({ id: `${LOCALE_PREFIX}.applyForBml.softDeclineMessage` });
            notificationMessage = defaultSoftDeclineMessage;
            notificationType = NOTIFICATION_TYPE.WARNING;

            if (softDeclineCustomMsg) {
                notificationMessage = _.get(
                    messages,
                    [LOCALE_PREFIX, 'applyForBml', 'customSoftDeclineMessages', softDeclineCustomMsg],
                    defaultSoftDeclineMessage
                );
            }
        }

        return notificationType ? <NotificationBanner message={notificationMessage} type={notificationType} /> : null;
    };

    render() {
        const {
            intl,
        } = this.props;

        return (
            <div className="outerWrapper de-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="ApplyPage">
                            <Header singleColumnLayout={true} msg={intl.formatMessage({id :`${LOCALE_PREFIX}.applyForInstHeading` })} />
                            <div id="content">
                                <div id="content-child" className="row-fluid table-layout">
                                    <div id="content-left" className="span14 table-cell pull-left">
                                        <section className="contentSection">
                                            <div id="notifications">
                                                {this.getNotifications()}
                                            </div>
                                            <ApplyPageForm />
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DEFooter />
                    </div>
                </div>
                <Footer />

            </div>
        );
    }
}

export const mapStateToProps = state => ({
    flow: _.get(state, 'serverData.flow'),
    hasSoftDeclineMsg: _.get(state, 'serverData.softDeclineMsg'),
    hasSubmitFailed: hasSubmitFailed(FORM_ID)(state),
    invalidAddressMsg: _.get(state, 'serverData.invalidAddressMsg'),
    messages: _.get(state, 'serverData.messages'),
    showValidationSoftDecline: _.get(state, 'serverData.showValidationSoftDecline'),
    softDeclineCustomMsg: _.get(state, 'serverData.softDeclineCustomMsg'),
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(props) {
        const {
            appStatus,
            showValidationSoftDecline,
            hasSoftDeclineMsg
        } = props;
        const extra = {};
        if (showValidationSoftDecline || hasSoftDeclineMsg) {
            extra.ppc_status = appStatus;
            dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_SOFT_DECLINED));
        } else {
            dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_START));
        }
        dispatch(trackTransition('pp_credit_applypage', 'prepare_pp_credit_applypage', extra));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ApplyPage));
